"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetFeatured = void 0;
const commands_1 = require("../models/commands");
const interfaces_1 = require("../models/interfaces");
class SetFeatured extends interfaces_1.CommandBase {
    constructor(cmd) {
        const body = {
            featured: cmd.featured ? 1 : 0,
        };
        super(commands_1.Command.SetFeatured, Object.assign(Object.assign({}, cmd), body));
    }
}
exports.SetFeatured = SetFeatured;
//# sourceMappingURL=setFeatured.js.map